import { Box, Card, Separator, Shimmer, ShimmerText } from '@betterment/samba-react';
import { ParentSize } from '@visx/responsive';

import { LoadingAccountProjectionChart } from '../../../../../Shared/components-v2/loading-Account-projection-chart/LoadingAccountProjectionChart';

export const ProjectionLoadingState = () => {
  return (
    <Card role="status" aria-label="Loading...">
      <Card.Header css={{ display: 'flex', flexDirection: 'column', padding: 'space.300', gap: 'space.50' }}>
        <ShimmerText textStyle="title200" css={{ maxWidth: '40%' }} />
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ p: 'space.300' }}>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.200' }}>
          <Box
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'space.100',
              alignItems: 'start',
              minWidth: 'size.0',
            }}
          >
            <ParentSize>
              {({ width }) => <LoadingAccountProjectionChart width={width} height={200} variant="loading" />}
            </ParentSize>
          </Box>
          <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <ShimmerText textStyle="text100" css={{ maxWidth: '50%' }} />
            <ShimmerText textStyle="text50" css={{ maxWidth: '20%' }} />
          </Box>
          <Box css={{ display: 'flex', flexDirection: 'row', gap: 'space.200' }}>
            <Shimmer css={{ width: '40px', height: '40px' }} />
            <ShimmerText textStyle="text25" css={{ maxWidth: '100%' }} />
          </Box>
          <ShimmerText textStyle="text25" css={{ maxWidth: '100%' }} />
        </Box>
      </Card.Content>
    </Card>
  );
};
